module.exports = __webpack_public_path__ + "static/media/dessert-image-1.0f92f0cb.png";